export const CARD_TYPE_ORDER = ['visa', 'mc', 'mir'];


export const CARD_TYPE_IMGS = {
  visa: {
    src: '/visaNew.png',
    alt: 'visa',
    className: 'badgeVisa',
    testId: 'card-visa'
  },
  mc: {
    src: '/mcNew.png',
    alt: 'masterCard',
    className: 'badgeMc',
    testId: 'card-masterCard'
  },
  mir: {
    src: '/mirNew.png',
    alt: 'mir',
    className: 'badgeMir',
    testId: 'card-mir'
  }
}
